module.exports = __webpack_public_path__ + "img/90301906.54a59728.png";